import { Map, OrderedSet, OrderedMap } from 'immutable';

import * as types from './types';
import { FailureTestRecord } from '../../records';

const initialState = Map({
  items: OrderedMap(),
  getTestsError: null,
  itemsCount: 0,
  loadingData: false,
  pagination: Map({
    size: 30,
    activePage: 0,
  }),
  jobOwnersFilter: Map({
    items: OrderedSet([]),
    selectedItems: OrderedSet([]),
  }),
});

const failureAnalysisReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_FAILURE_TESTS.REQUEST:
      return state.withMutations((newState) => {
        newState
          .set('loadingData', true)
          .set('items', initialState.get('items'));
      });
    case types.GET_FAILURE_TESTS.SUCCESS:
      return state.withMutations((newState) => {
        const items = OrderedMap(
          payload.results.reduce((acc, item) => ({
            ...acc,
            [item.id]: new FailureTestRecord({
              id: item.id,
              name: item.name,
              testCount: item.count,
              rootCauseUrl: item.root_causes_url,
            }),
          }), {}),
        );
        newState.set('items', items);
        newState.set('itemsCount', payload.total);
        newState.set('loadingData', false);
        newState.set('getTestsError', null);
      });
    case types.GET_JOBS_OWNERS.SUCCESS:
      return state.withMutations((newState) => {
        const existingItems = newState.getIn(['jobOwnersFilter', 'items']).map(({ name }) => name);
        const newItems = OrderedSet(
          payload.results
            .filter((item) => !existingItems.has(item))
            .map((item) => ({
              label: item,
              name: item,
            })),
        );
        newState.updateIn(['jobOwnersFilter', 'items'], (items) => items.union(newItems));
      });
    case types.SET_JOBS_OWNER:
      return state.setIn(['jobOwnersFilter', 'selectedItems'], OrderedSet(payload));
    case types.SET_OWNER_FROM_QUERYSTRING:
      return state.withMutations((newState) => {
        const existingItems = newState.getIn(['jobOwnersFilter', 'items']).map(({ name }) => name);
        const newItems = [{ label: payload, name: payload }];
        if (!existingItems.has(payload)) {
          newState.updateIn(['jobOwnersFilter', 'items'], (items) => items.union(newItems));
        }
        newState.setIn(['jobOwnersFilter', 'selectedItems'], OrderedSet([payload]));
      });
    case types.GET_FAILURE_TESTS.FAILURE:
      return state.withMutations((newState) => {
        newState
          .set('getTestsError', payload)
          .set('loadingData', false);
      });
    case types.CHANGE_PAGINATION:
      return state.set('pagination', payload);
    case types.CLEANUP:
      return initialState;
    case types.GET_ROOT_CAUSES.REQUEST:
      return state.setIn(['items', payload.index, 'loading'], true);
    case types.GET_ROOT_CAUSES.SUCCESS:
      return state.withMutations((newState) => {
        newState
          .setIn(['items', payload.index, 'loading'], false)
          .setIn(['items', payload.index, 'rootCauses'], payload.results);
      });
    case types.GET_ROOT_CAUSES.FAILURE:
      return state.setIn(['items', payload.index, 'loading'], false);
    default:
      return state;
  }
};

export default failureAnalysisReducer;
export { initialState };
